import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";

import { ZhhRealityCheckAlertContent } from "./zhh-reality-check-alert.model";

@Component({
	selector: "obg-zhh-reality-check-alert-container",
	templateUrl: "./zhh-reality-check-alert.container.html",
	styleUrls: ["./zhh-reality-check-alert.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ZhhRealityCheckAlertContainer {
	constructor(@Inject(MAT_DIALOG_DATA) public data: ZhhRealityCheckAlertContent | undefined) {}
}
